import {timeInSeconds} from "./timeInSeconds";
import {getStoredSessionTimeout} from "./getStoredSessionTimeout";
import {END_SESSION_TIMEOUT_IN_SECONDS} from "../config/constants";

export const logoutIfTimePassed = ({handleLogout}) => {
    const passedSeconds = timeInSeconds() - getStoredSessionTimeout();
    const remainingSeconds = END_SESSION_TIMEOUT_IN_SECONDS - passedSeconds;

    // Checking for handling Logout after passing the waiting time
    if (remainingSeconds <= 0) {
        handleLogout()
    }
}